export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14848.3275d460.jpg";